// ./reservebar-button-state.js

import {
	buildAddressParams,
	createProductStoreKey,
	getLiquidAddressObject,
	getLiquidClient,
	getReservebarStore,
	selectPreferredRetailer
} from './reservebar-config';
import {getAddresParams} from 'Assets/js/modules/library-modules/reservebar/reservebar-cart-modal';

// Which buttons do we control (you can change the selector to suit your HTML)
const PRICE_SELECTOR = '.reservebar-price';

/**
 * Setup of all ReserveBar buttons
 * */
export function initReservebarPrice() {
	refreshReservebarPrice();

	window.addEventListener('reservebar:address-updated', () => {
		refreshReservebarPrice();
	});

	window.addEventListener('reservebar:buttons-added', () => {
		refreshReservebarPrice();
	});
}

/**
 * List the states of all prices
 */
function refreshReservebarPrice() {
	const prices = Array.from(document.querySelectorAll(PRICE_SELECTOR));
	if (!prices.length) return;

	const addrObj = getLiquidAddressObject();
	if (!addrObj) {
		prices.forEach((el) => el.style.display = 'none');
		return;
	}

	const store = getReservebarStore();

	getLiquidClient().then((liquid) => {
		prices.forEach((priceEl) => {
			const gid = priceEl.getAttribute('reservebar-liquid-id');
			if (!gid || gid === 'false') {
				priceEl.style.display = 'none';
				return;
			}

			const params = getAddresParams(gid);
			const storeKey = createProductStoreKey(gid, addrObj);

			// 1) Try from cache
			if (store && storeKey) {
				const cached = store.getProduct(storeKey);
				if (cached) {
					applyProductStateToPrice(priceEl, cached);
					return;
				}
			}

			// 2) No cache → call API
			loadPriceState(liquid, priceEl, params, storeKey);
		});
	});
}

function applyProductStateToPrice(priceEl, productState) {
	if (!productState || !productState.hasPrice) {
		priceEl.style.display = 'none';
		return;
	}

	const valueEl = priceEl.querySelector('.price-value');
	let priceText = productState.price;
	const num = parseFloat(productState.price);
	if (!isNaN(num)) {
		priceText = `$${num.toFixed(2)}`;
	}
	if (valueEl) {
		valueEl.textContent = priceText;
	}

	priceEl.style.display = '';
}

/**
 * Calling liquid.product for a single button and updating its status
 */
function loadPriceState(liquid, priceEl, params, storeKey) {
	const store = getReservebarStore();

	// 1) Try to retrieve from cache
	if (store && storeKey) {
		const cached = store.getProduct(storeKey);

		if (cached) {
			applyProductStateToPrice(priceEl, cached);
			return;
		}
	}

	// 2) If there is nothing in the cache, go to liquid.product
	liquid
		.product(params)
		.then((products) => {
			let product = null;

			if (Array.isArray(products)) {
				product = products[0] || null;
			} else if (products && Array.isArray(products.products)) {
				product = products.products[0] || null;
			}

			if (!product || !Array.isArray(product.variants)) {
				priceEl.style.display = 'none';
				return;
			}

			const firstVariant = product.variants[0];
			let price = null;
			let firstRetailer = null;

			if (firstVariant && Array.isArray(firstVariant.retailers)) {
				firstRetailer =
					selectPreferredRetailer(
						firstVariant.retailers,
						firstVariant
					) || null;
				if (firstRetailer && firstRetailer.price) {
					price = firstRetailer.price;
				}
			}

			const productState = {
				hasPrice: !!price,
				price: price || null,
				productId: firstVariant ? firstVariant.productId : null,
				variantId: firstRetailer ? firstRetailer.variantId : null,
				retailer: firstRetailer ? firstRetailer.retailer : null,
				shippingMethod: firstRetailer
					? firstRetailer.shippingMethod
					: null,
				raw: {
					product,
					variant: firstVariant,
					retailer: firstRetailer
				}
			};

			// save to Store
			if (store && storeKey) {
				store.setProduct(storeKey, productState);
			}

			applyProductStateToPrice(priceEl, productState);
		})
		.catch((e) => {
			console.error(
				'[ReserveBar] failed to load product state for price',
				e
			);
			priceEl.style.display = 'none';
		});
}
